<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <div v-html="data[name]" :class="className"></div>
    </el-col>
</template>

<script>
    import qweBaseField from "../BaseField"
    export default{
        name:"DescriptionField",
        mixins:[qweBaseField]
    }
</script>